/*
  pn-consent — reclaims a row from Shopify's privacy banner on small screens.

  WHY THIS AND NOT A TEXT CLAMP. The obvious assumption is that the legal paragraph is what makes the
  banner tall, so the fix is to clamp it. Measured at 375x812 before touching anything:

      banner  167px  (21% of the viewport)
      body     35px  — the paragraph is already only TWO lines
      buttons  99px  — GÉRER VOS PRÉFÉRENCES on its own row above ACCEPTER / REFUSER

  The buttons are 59% of the banner. Clamping the text would have saved nothing and would have put a
  legal question on the table for no benefit.

  So the third control moves inline next to the privacy-policy link it already sits beside in meaning,
  and the button block collapses to a single 44px row. Nothing is hidden, nothing is removed, nothing
  is made harder to reach: it stays a real <button> with its own handler and a 44px tap target, and
  Accept and Refuse keep identical weight — a French storefront must make refusing exactly as easy as
  accepting.

  Restored on resize back to desktop, where the banner is a single row already and there is no
  problem to solve.
*/
(function () {
  const BREAKPOINT = 989;
  let banner = null;
  let manageBtn = null;
  let home = null; // where Shopify originally put the button, so it can go back

  function apply() {
    if (!banner || !manageBtn || !home) return;
    const small = window.innerWidth <= BREAKPOINT;
    const body = banner.querySelector('.shopify-pc__banner__body');
    if (!body) return;

    if (small && manageBtn.parentElement !== body) {
      body.appendChild(manageBtn);
      banner.classList.add('pn-consent--compact');
    } else if (!small && manageBtn.parentElement === body) {
      home.insertBefore(manageBtn, home.firstChild);
      banner.classList.remove('pn-consent--compact');
    }
  }

  /*
    Publish the banner's height so anything else pinned to the bottom can sit ABOVE it rather than
    under it. The sticky add-to-cart used to hide itself while consent was open, which meant a mobile
    shopper who had scrolled past the buy box had no add-to-cart at all until they answered the
    banner — the visual judge caught exactly that ("no sticky ATC... the buy-box ATC is stranded far
    above"). Stacking is the better answer than hiding: consent stays uncoverable, and the shopper
    keeps a way to buy.
  */
  function publishHeight() {
    if (!banner || !banner.isConnected) {
      document.documentElement.style.setProperty('--pn-consent-h', '0px');
      return;
    }
    // NOT offsetParent: it is null for every position:fixed element, and this banner is fixed — so
    // an offsetParent check reports "hidden" even while the banner is plainly on screen, and the
    // height published as 0px while the sticky bar sat 153px underneath it.
    const visible = getComputedStyle(banner).display !== 'none' && banner.getBoundingClientRect().height > 0;
    const h = visible ? Math.round(banner.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--pn-consent-h', `${h}px`);
  }

  function attach(el) {
    banner = el;
    manageBtn = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    home = manageBtn && manageBtn.parentElement;
    if (!manageBtn || !home) return false;
    apply();
    publishHeight();
    window.addEventListener('resize', () => { apply(); publishHeight() }, { passive: true });
    // The banner removes itself once answered, and its height changes when the layout switches
    // between compact and full — both have to reach anything stacked on top of it.
    new ResizeObserver(publishHeight).observe(banner);
    new MutationObserver(publishHeight).observe(document.body, { childList: true });
    // Shopify sizes the banner over a couple of frames after injecting it; one read on attach can
    // land before the final layout.
    for (const t of [0, 120, 400, 1200]) setTimeout(publishHeight, t);
    return true;
  }

  const existing = document.getElementById('shopify-pc__banner');
  if (existing && attach(existing)) return;

  // Shopify injects the banner asynchronously, after its own consent script decides the visitor's
  // region needs it — so there is nothing to attach to at DOMContentLoaded.
  const observer = new MutationObserver(() => {
    const el = document.getElementById('shopify-pc__banner');
    if (el && attach(el)) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  // Stop watching the whole document once the banner can no longer plausibly arrive.
  setTimeout(() => observer.disconnect(), 15000);
})();
